import { Box, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

type Props = {
  label: string;
  id: string;
  client: string;
  screen: number;
  defaultValue: number;
  updateParentValue: (id: string, index: string) => void;
};

const LaneButtonIcon = ({ label, id, client, screen, defaultValue, updateParentValue }: Props) => {
  const [selectedIcon, setSelectedIcon] = useState<number>(defaultValue);

  const handleIconButtonClick = () => {
    let newIconNum = (selectedIcon + 1) % 4;
    if (newIconNum == 0) newIconNum = 1;
    setSelectedIcon(newIconNum);
    updateParentValue(id, `${newIconNum}`);
  };

  useEffect(() => {
    setSelectedIcon(defaultValue);
  }, [screen, defaultValue]);

  return (
    <Box display={'flex'} flexDirection={'column'} width={'100%'}>
      <Typography textAlign={'center'} pt={1} pb={1} fontWeight={'bold'}>
        Lane {label}
      </Typography>
      <Box height={'6vh'} onClick={handleIconButtonClick}>
        <img
          src={`${process.env.REACT_APP_API_PUBLIC_BASE_URL}/lane-management/${client}/static-icons/${selectedIcon}.png`}
          alt=''
          height={'100%'}
          width={'100%'}
        />
      </Box>
    </Box>
  );
};

export default LaneButtonIcon;
